import AdminUsers from "@pages/Users";


export const AdminUsersRoutes = [
    {
      path: "/admin/users",
      name: "Users",
      component: AdminUsers,
    },
]